import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { CateringBotState, RootState } from '../types';

const namespaced: boolean = true;

export const state: CateringBotState = {};

export const CateringBot: Module<CateringBotState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default CateringBot;
